import { defineFcm } from '../shared/factory';

export const FCM_SEARCH_V2_MAINTENANCE = defineFcm('search_v2_maintenance')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Search page v2',
		description: `Determines whether the new search page v2 is in maintenance mode.

		This flag allows us to safely perform maintenance on the Typesense server for specific locales without impacting other regions.`,
	});
